import { useQuery } from '@tanstack/react-query'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'

import { useCurrentWalletAddress } from './useCurrentWalletAddress'

export const telegramConnectionQueryKey = (walletAddress?: string) =>
  ['telegramConnection', walletAddress] as const

export const useIsTelegramConnected = () => {
  const walletAddress = useCurrentWalletAddress()
  const backendClient = useBackendClient()

  const { data: connectionStatus } = useQuery({
    queryKey: telegramConnectionQueryKey(walletAddress),
    queryFn: async () => {
      if (!walletAddress) return { isConnected: false }
      return backendClient.getTelegramConnection(walletAddress)
    },
    enabled: !!walletAddress,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })

  return connectionStatus
}
